<script>
import InlineSVG from 'svelte-inline-svg'
import { providers } from '../common'

let usmapPath = '/img/us-map-with-cities.svg' // edit with https://www.vecteezy.com/editor
let title = "Conclusions"

</script>
<section>
  <div class="section-body">

    <div classA="row">
      <div classA="col-lg-8">

        <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInUp">{title}</h2>

          <div class="fact-box ioreveal animate__animated animate__delay-1s" style="animation-delay: .3s;" data-anicss="animate__fadeInUp">
            <div class="fact-box-title"><span style="color: #18c7de" class="material-icons">directions_bike</span> Bikeshare has emerged as a resilient way to move around</div>
            <div class="fact-box-info">
             <ul>
              <li> Bike share has provided a critical socially distanced service during the pandemic. While peak levels dropped significantly, off-peak travel has remained stable over the 2019-20 period. </li>
              <li>Demand has started to grow from pre-Covid levels. It is worth noting that while vaccines started increasing around Feb-April 2021, cities did not open up immediately and operators have not fully returned to its pre-COVID operations.  </li>
              <li>Behavior change is noticeable, including significantly longer trips patterns (with the exception of Boston) : as more people return to the office, bike share offers a socially-distanced first-last mile option for people who are hesitant to shift back to group transportation options, but care about the environment and want to maintain the healthy habits that they increased during the pandemic.</li>
             </ul>
            </div>
          </div>

          <div class="fact-box ioreveal animate__animated animate__delay-1s" style="animation-delay: .5s;" data-anicss="animate__fadeInUp">
            <div class="fact-box-title"><span class="material-icons">location_city</span> City governments support to increase cycling levels</div>
            <div class="fact-box-info">
            <ul>
              <li>Some cities have temporarily or permanently expanding cycling infrastructure in response to the pandemic</li>
              <li>Residents have responded with increased usage and growth in annual memberships</li>
              <li>Bike share can help with health and wellness, in addition to commuting and errand trips </li>
            </ul>
            </div>
          </div>

          <div class="fact-box ioreveal animate__animated animate__delay-1s" style="animation-delay: .7s;" data-anicss="animate__fadeInUp">
            <div class="fact-box-title"><span class="material-icons">construction</span> Building back better</div>
            <div class="fact-box-info">
            <ul>
              <li>There is significant potential to maintain and build on demand realized</li>
              <li>Cities can support the shift to cycling through making permanent temporary cycle infrastructure improvements</li>
              <li>Bike share systems support the realization of the 15 minute city concept</li>
              <li>Increased demand helps to make the case for service densification, electrification and expansion</li>
            </ul>
            </div>
          </div>

      </div>
    </div>
  </div>
</section>

<style>
.row {
  text-align: left;
}
.section-body {
  /* max-width: 960px;
  padding: 30px;
  margin: auto; */
  /* margin-left: 200px; */
  text-align: left;
}

.fact-box {
  margin-top: 28px;
}
li {
  margin-bottom: 13px;
  margin-left: 20px;
  font-size: 15px;
  line-height: 150%;
}
li img {
  margin: 5px 0 6px 0;
  /* height: 22px; */
}

.material-icons {
  color: #18c7de;
  font-size: 36px;
  float: left;
  margin-right: 8px;
}
</style>